import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const IconMenu = (props) => (
    <svg
        {...props}
        fill='none'
        height={16}
        viewBox='0 0 16 16'
        width={16}
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M1 1.375H15V2.625H1V1.375Z'
            fill='currentColor'/>
        <path
            d='M1 7.375H15V8.625H1V7.375Z'
            fill='currentColor'/>
        <path
            d='M1 13.375V14.625H15V13.375H1Z'
            fill='currentColor'/>
    </svg>
);

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconMenu;
